import React, { ChangeEvent } from 'react';
import moment from 'moment/moment';
import { Input } from '../../../components';
import { ChargebackFormProps } from './index.types';
import SelectComponent from '../../../components/SelectComponent';

const ChargebackForm = ({
  payments,
  formDetails,
  setFormDetails,
}: ChargebackFormProps) => (
  <form>
    <div style={{ display: 'flex', gap: '1rem' }}>
      <div style={{ width: '100%', height: '53px' }}>
        <SelectComponent
          data={payments}
          label="Payments"
          selected={formDetails.paymentId || ''}
          onSelect={(value: string) =>
            setFormDetails({ key: 'paymentId', value })
          }
        />
      </div>
      <div style={{ width: '100%' }}>
        <Input
          placeholder="Chargeback request date"
          name="requestDate"
          value={formDetails.requestDate}
          type="date"
          onChange={(e: any) => {
            setFormDetails({
              key: 'requestDate',
              value: moment(e.currentTarget.value).format('YYYY-MM-DD'),
            });
          }}
        />
      </div>
    </div>
    <div className="form-row">
      <div className="input-hint">
        <Input
          name="Auth code"
          placeholder="Auth code"
          value={formDetails.authCode}
          maxLength={20}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFormDetails({ key: 'authCode', value: e.target.value });
          }}
        />
      </div>
      <div className="form-row-divider" />
      <Input
        name="ARN"
        placeholder="ARN"
        value={formDetails.arn}
        maxLength={20}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setFormDetails({ key: 'arn', value: e.target.value });
        }}
      />
    </div>
  </form>
);

export default ChargebackForm;
